import { render, staticRenderFns } from "./ConsumptionComparison.vue?vue&type=template&id=00f87568&scoped=true&"
import script from "./ConsumptionComparison.vue?vue&type=script&lang=js&"
export * from "./ConsumptionComparison.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f87568",
  null
  
)

export default component.exports